import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PersonaService } from '../http/apiPersona/persona.service';
import { IUser } from '../interfaces/shared/IUser';
import { Persona } from '../interfaces/shared/persona.model';
import { SessionStorageService } from './session-storage/session-storage.service';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    private userSubject = new BehaviorSubject<IUser>(null);
    public _user: Observable<IUser> = this.userSubject.asObservable();

    constructor(
        private sessionStorageService: SessionStorageService,
        private PersonaService: PersonaService
    ) {
        this.loadSession();
    }

    set User(user: IUser) {
        this.userSubject.next(user);
    }

    get User(): IUser {
        return this.userSubject.getValue();
    }

    loadSession(): void {
        this.User = this.sessionStorageService.get('User') as IUser;
    }

    saveSession(): void {
        this.sessionStorageService.set('User', this.User);
    }

    addUserProperties(persona_data: IUser | Persona): void {
        const properties = { ...this.User, ...persona_data } as IUser;
        this.User = properties;
        this.saveSession();
    }

    deleteUserObject(): void {
        this.User = {};
        this.saveSession();
    }

    getDataUser(): void {
        this.PersonaService.getPersona().subscribe(res => {
            this.addUserProperties(res);
        })
    }
}

